<template>
  <!-- <v-layout> -->
  <v-container fluid grid-list-md>
    <v-layout row wrap mt-5>
      <Auth />
      <Navbar />
      <Messages />
    </v-layout>
  </v-container>
  <!-- </v-layout> -->
</template>

<script>
import Navbar from "@/views/Navbar";
import Auth from "@/components/Auth";
import Messages from "@/components/Messages";

export default {
  components: {
    Auth,
    Navbar,
    Messages
  }
};
</script>

<style lang="scss" scoped></style>
